import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import Login from './views/public/Login'
import PasswordRecover from './views/public/PasswordRecover'
import Register from './views/public/Register'
import Home from './views/auth/Home.vue'
import User from './views/auth/User.vue'
import Link from './views/auth/Link.vue'
import Pdf from './views/auth/Pdf.vue'



Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [

        {
            path: '*',
            redirect: '/'
        },

        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/recover',
            name: 'Recover',
            component: PasswordRecover
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/user',
            name: 'User',
            component: User,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/link',
            name: 'Link',
            component: Link,
            meta: {
                requiresAuth: true
            },

        },
        {
            path: '/pdf',
            component: Pdf,
            meta: {
                requiresAuth: true
            },
        },
    ]
});

router.beforeEach((to, from, next) => {
    let currentUser = firebase.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth && !currentUser) next({name: 'Login'});
    else if (!requiresAuth && currentUser) next({name: 'Home'});
    else next()
});

export default router;
